import BRequest from "./BRequest";
import BSelect from "../front/Modules/BSelect";

export default class BDialogTrigger
{
	constructor(el)
	{
		this.el = el;
	}

	static initialize()
	{
		this.addEventListeners();
	}

	static addEventListeners()
	{
		document.addEventListener("click", event => {
			const selector = `[data-dialog-selector]`;
			if (event.target.matches(`${selector}, ${selector} *`)) {
				event.preventDefault();

				void new this(event.target.closest(`${selector}`)).openModal();
			}
		});

		document.addEventListener("click", event => {
			if (event.target.matches(`.dialog .close-button, .dialog .close-button *, .dialog__close-button, .dialog__close-button *, .jp-dialog__close, .jp-dialog__close *`)) {
				const dialog = event.target.closest(`dialog`);
				if (dialog) {
					dialog.close();
				}
			}
		});

		document.addEventListener("click", event => {
			const dialog = event.target.closest("dialog");
			if (dialog && event.target === dialog) {
				dialog.close();
			}
		});
	}

	/**
	 * Native showModal() focuses the first focusable control (often close).
	 * Prefer the first real field so typing starts immediately.
	 * TomSelect replaces native focus — use its API when present (ID-1154).
	 */
	static focusFirstField(dialog)
	{
		if (!dialog) {
			return;
		}

		const fields = dialog.querySelectorAll(
			"input:not([type=\"hidden\"]):not([type=\"button\"]):not([type=\"submit\"]):not([type=\"reset\"]):not([disabled]), select:not([disabled]), textarea:not([disabled])",
		);

		for (const field of fields) {
			if (field.closest("[hidden], [aria-hidden=\"true\"]")) {
				continue;
			}
			if (field.closest(".ts-dropdown")) {
				continue;
			}
			if (field.type === "file" || field.closest(".drag-drop-upload")) {
				continue;
			}
			if (field.getAttribute("tabindex") === "-1") {
				continue;
			}

			if (field.tomselect) {
				field.tomselect.focus();
				field.tomselect.open();
				return;
			}

			field.focus();
			return;
		}
	}

	static afterOpen(dialog, scrollX, scrollY)
	{
		window.scrollTo(scrollX, scrollY);
		dialog.querySelectorAll(BSelect.selector()).forEach(el => {
			BSelect.initializeElement(el);
		});
		dialog.dispatchEvent(new CustomEvent("jp-dialog-opened", { bubbles: true }));
		BDialogTrigger.focusFirstField(dialog);
	}

	async openModal()
	{
		const dialog = document.querySelector(this.el.dataset.dialogSelector);
		if (!dialog) return;

		const scrollX = window.scrollX;
		const scrollY = window.scrollY;

		const asyncSrc = dialog.dataset.asyncDialogSrc;
		const bodyEl = dialog.querySelector("[data-async-dialog-body]");
		if (asyncSrc && dialog.dataset.asyncDialogLoaded !== "1") {
			if (dialog.dataset.asyncDialogLoaded === "loading") {
				dialog.showModal();
				window.scrollTo(scrollX, scrollY);

				return;
			}
			dialog.dataset.asyncDialogLoaded = "loading";
			dialog.showModal();
			window.scrollTo(scrollX, scrollY);
			try {
				const axiosResponse = await BRequest.get(asyncSrc, {}, {
					headers: {
						Accept: "application/json",
						...(dialog.dataset.diaryWebChrome
							? { "X-Diary-Web-Chrome": dialog.dataset.diaryWebChrome }
							: {}),
					},
				});
				const templateKey = dialog.dataset.asyncDialogTemplate || "mealEditDialog";
				const html = axiosResponse.data?.templates?.[templateKey];
				if (typeof html === "string" && bodyEl) {
					bodyEl.innerHTML = html;
					dialog.dataset.asyncDialogLoaded = "1";
				} else {
					throw new Error(`${templateKey} template missing`);
				}
			} catch {
				dialog.dataset.asyncDialogLoaded = "";
				if (bodyEl) {
					bodyEl.innerHTML = "<p class=\"jp-dialog__error\">Nepodařilo se načíst formulář. Zkuste stránku obnovit.</p>";
				}
				requestAnimationFrame(() => {
					window.scrollTo(scrollX, scrollY);
				});

				return;
			}
			requestAnimationFrame(() => {
				BDialogTrigger.afterOpen(dialog, scrollX, scrollY);
			});

			return;
		}

		// showModal() runs "dialog focusing steps" which can scroll the page
		// to the dialog's DOM position. Lock the scroll for the current frame.
		dialog.showModal();
		window.scrollTo(scrollX, scrollY);

		requestAnimationFrame(() => {
			BDialogTrigger.afterOpen(dialog, scrollX, scrollY);
		});
	}
}
